const appConfig = window.appConfig;

export default appConfig;